import type { GraphQLFormattedError } from 'graphql';
import type { ErrorResponse } from '@apollo/client/link/error';
import normalizeGraphQLError from './normalizeGraphQLError';

export default function handleApolloError(
  apolloError: Error | ErrorResponse,
  key?: string | Record<string, (error: GraphQLFormattedError) => unknown>,
  handler?: (error: GraphQLFormattedError) => unknown,
  fallback?: (error: GraphQLFormattedError) => unknown,
) {
  if (!apolloError) return;

  const handlers = typeof key === 'string' ? { [key]: handler } : key;
  const fallbackHandler = typeof key === 'string' ? fallback : handler;

  ('graphQLErrors' in apolloError
    ? (apolloError.graphQLErrors ?? [])
    : []
  ).forEach((err) => {
    const { code } = normalizeGraphQLError(err);
    if (code && handlers?.[code]) {
      handlers[code]?.(err);
    } else if (fallbackHandler) {
      fallbackHandler(err);
    }
  });
}
